import { Bookings } from '@/types/types'

class OfferHelpers {
  static getStock(offer: Bookings.SelectedOffer) {
    if (offer.stock < (offer.capacity?.min || 1)) {
      return 0
    }

    return Math.min(offer.stock, offer.capacity?.max ?? Infinity)
  }

  static isWithinStock(offer: Bookings.SelectedOffer) {
    return offer.count <= this.getStock(offer)
  }

  static respectsSameForAll(offer: Bookings.SelectedOffer, pax: number) {
    return !offer.config?.is_same_for_all || offer.count === pax
  }

  static isWithinPaxLimits(offer: Bookings.SelectedOffer, pax: number) {
    return (
      (!offer.config?.min_pax_available || offer.config.min_pax_available <= pax) &&
      (!offer.config?.max_pax_available || offer.config.max_pax_available >= pax)
    )
  }

  static isPossibleForPax(offer: Bookings.SummaryOffer, pax: number) {
    return offer.possible_guests.includes(pax)
  }
}

export default OfferHelpers
